import { EstateTask_CreateEstateTaskInput, useEstateTask_CreateEstateTaskMutation } from 'queries';

import Modal from 'common/modal';
import { NotificationSeverity, showAlert, showToast } from 'utils/notification-manager';

import EstateTaskForm from './estate-task-form';

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function CreateEstateTaskModal({ setShowModal, showModal }: Props) {
  const onExitClick = () => {
    setShowModal(false);
  };

  const [createEstateTask, { loading: createEstateTaskExecuting }] =
    useEstateTask_CreateEstateTaskMutation({
      onCompleted: () => {
        setShowModal(false);
        showToast({
          message: 'Estate task created successfully',
          severity: NotificationSeverity.SUCCESS,
        });
      },
      onError: (e) =>
        showAlert({
          message: `Error creating estate task: ${e.message}`,
          severity: NotificationSeverity.ERROR,
        }),
    });

  const onSubmit = async (formData: EstateTask_CreateEstateTaskInput) => {
    createEstateTask({
      variables: {
        input: {
          ...formData,
        },
      },
    });
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={<EstateTaskForm onSubmit={onSubmit} isSaveDisabled={createEstateTaskExecuting} />}
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
